import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App.jsx"
import './index.css'  // Add this import for Tailwind

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)